import React from 'react';
import classNames from 'classnames';

interface Props extends React.HTMLAttributes<HTMLDivElement> {}

const Container = ({ children, ...props }: Props) => {
	return (
		<div
			className={classNames(
				'container mx-auto w-full px-[16px] xl:px-[80px] max-w-[1440px]',
				// "container mx-auto sm:w-[96%] m-auto w-[90%] max-w-[1366px] pb-[20px] sm:!px-0 sm:pb-[80px]",
				props.className,
			)}
			style={{ ...props.style }}
		>
			{children}
		</div>
	);
};

export default Container;
